let config = null;
const fromApi = import.meta.env.VITE_CONFIG_SOURCE === 'api';

export const loadConfig = async () => {
  if (!fromApi) {
    config = import.meta.env;
    return;
  }
  const res = await fetch('/api/config', { cache: 'no-store' });
  if (!res.ok) throw new Error(`GET /api/config failed: ${res.status}`);
  config = await res.json();
};

export const getConfig = () => {
  if (config) return config;
  if (fromApi) throw new Error('getConfig() called before loadConfig() resolved');
  return import.meta.env;
};
